// React
import React from "react";

import { useTranslation } from "react-i18next";

// Components
import { NotificationsIcon } from "components/ui/icons";

import NotificationItem from "./NotificationItem";

const NotificationsList = ({ loading, notifications, onNotificationClick }) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <div>
        <div className="p-6 text-center" role="status">
          <div className="animate-spin motion-reduce:animate-none rounded-full h-6 w-6 border-b-2 border-primary mx-auto"></div>
          <p className="mt-2 text-sm text-gray-600">
            {t("notifications:notificationsList.loading")}
          </p>
        </div>
      </div>
    );
  }

  if (notifications.length === 0) {
    return (
      <div>
        <div className="p-6 text-center">
          <NotificationsIcon className="w-8 h-8 mx-auto text-gray-400 mb-2" />
          <p className="text-sm text-gray-600">{t("notifications:notificationsList.empty")}</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="flex flex-col gap-2">
        {notifications.map((notification) => (
          <NotificationItem
            key={notification.id}
            notification={notification}
            onClick={() => onNotificationClick(notification)}
          />
        ))}
      </div>
    </div>
  );
};

export default NotificationsList;
